import React, { Component } from "react";
import {
  InputGroup,
  FormControl,
  Button,
  FormGroup,
  Glyphicon
} from "react-bootstrap";

class ButtonInputGroup extends Component {
  handleOnChange(ev) {
    let { model, dataMember } = this.props;
    if (model && dataMember) {
      model[dataMember] = ev.target.value;
    }
  }

  render() {
    let {
      id,
      type,
      model,
      dataMember,
      placeholder,
      readOnly,
      disabled,
      glyphicon,
      onClick,
      value
    } = this.props;

    if (model && dataMember) {
      value = model[dataMember];
    }

    value = value || "";

    return (
      <div>
        <FormGroup>
          <InputGroup>
            <FormControl
              id={id}
              value={value || ""}
              type={type}
              placeholder={placeholder || ""}
              onChange={this.handleOnChange.bind(this)}
              readOnly={readOnly}
            />
            <InputGroup.Button>
              <Button onClick={onClick} disabled={disabled}>
                <Glyphicon glyph={glyphicon} />
              </Button>
            </InputGroup.Button>
          </InputGroup>
        </FormGroup>
      </div>
    );
  }
}

export default ButtonInputGroup;



// WEBPACK FOOTER //
// ./src/Core/Components/Inputs/ButtonInputGroup/index.js